import React from 'react';
import { Button } from 'antd';
import {
  useBQRoutinesSyncStatusSubscription,
  useGetBQRoutinesSyncStatus,
} from 'query/acg/phase-1';
import { useSyncBQRoutines } from 'mutation/acg/phase-1';

export default function SyncBQRoutineStatusButton() {
  const { data, isLoading } = useGetBQRoutinesSyncStatus();
  const { isLoading: mutationLoading, mutate } = useSyncBQRoutines();
  useBQRoutinesSyncStatusSubscription();
  return (
    <Button
      disabled={!data}
      loading={isLoading || data?.isSyncing || mutationLoading}
      onClick={mutate}
    >
      {data?.isSyncing ? 'Syncing' : 'Sync BQ Routines'}
    </Button>
  );
}
